
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/white-glove-service",
      function () {
        return require("private-next-pages/events/white-glove-service.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/white-glove-service"])
      });
    }
  